import React, { useState } from 'react';
import styled from 'styled-components';
import { FaMapMarkerAlt, FaUser, FaTimes } from 'react-icons/fa';

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: #e8f5e9;
`;

const LocationWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  color: #263238;
  cursor: pointer;
`;

const ProfileIcon = styled(FaUser)`
  color: #66bb6a;
  font-size: 1.5rem;
`;

const DrawerOverlay = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  justify-content: center;
  align-items: flex-end; /* Align content to the bottom */
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const DrawerContent = styled.div`
  background: #ffffff;
  width: 100%;
  max-width: 500px;
  border-radius: 20px 20px 0 0; /* More rounded top corners */
  padding: 1.5rem;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease-out;
  overflow-y: auto;
  
  @keyframes slideUp {
    from {
      transform: translateY(100%); /* Start below the screen */
    }
    to {
      transform: translateY(0); /* Slide up to the final position */
    }
  }

  /* Desktop Styles */
  @media (min-width: 768px) {
    width: 80%;
    max-width: 900px;
    position: absolute;
    bottom: 0;
    left: 10%;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  }
`;

const DrawerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 1rem;
`;

const CloseIcon = styled(FaTimes)`
  cursor: pointer;
  font-size: 1.5rem;
  color: #888;
`;

const CityOption = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem 0;
  font-size: 1rem;
  color: #444;
  cursor: pointer;

  input {
    margin-right: 0.5rem;
  }

  &:hover {
    background-color: #f0f0f0;
    border-radius: 5px;
  }
`;

const Header = () => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [selectedCity, setSelectedCity] = useState("Melvisharam");

  const toggleDrawer = () => setDrawerOpen(!isDrawerOpen);
  const selectCity = (city) => {
    setSelectedCity(city);
    toggleDrawer();
  };

  return (
    <>
      <HeaderContainer>
        <LocationWrapper onClick={toggleDrawer}>
          <FaMapMarkerAlt color="#388e3c" />
          <span>{selectedCity}</span>
        </LocationWrapper>
        <ProfileIcon />
      </HeaderContainer>

      <DrawerOverlay isOpen={isDrawerOpen} onClick={toggleDrawer}>
        <DrawerContent onClick={(e) => e.stopPropagation()}>
          <DrawerHeader>
            <span>Select Your Place</span>
            <CloseIcon onClick={toggleDrawer} />
          </DrawerHeader>

          {["Melvisharam", "Kilvisharam", "Arcot", "Ranipet", "Vellore"].map((city) => (
            <CityOption key={city} onClick={() => selectCity(city)}>
              <input
                type="radio"
                name="city"
                checked={selectedCity === city}
                readOnly
              />
              {city}
            </CityOption>
          ))}
        </DrawerContent>
      </DrawerOverlay>
    </>
  );
};

export default Header;
